import axios, { AxiosResponse } from 'axios'
import { APIRequestErrorType, APIRequestState, Endpoint, RoleMimetype, URL } from 'constants/API'
import { ActionRequest, StatusResponseBody } from 'models/redux'
import { SignedUrlDownloadRequestBody, UrlDTO } from 'models/visuals'

import { expose } from 'comlink'
import { ActionTypeAPIData } from 'constants/redux'
import { APIRequest } from 'models/API'
import { generalFetch } from 'redux/Helpers'
import { ActionLoadVisual } from 'redux/Individual/Visual/LoadVisual'

const delayTime = 2000
const iterationCount = 30

const waitFor = (millis: number) => {
  return new Promise((resolve) => {
    setTimeout(resolve, millis)
  })
}

async function downloadVisualWorker(receivedAction: ActionLoadVisual, token: string, mimetype: RoleMimetype) {
  const dataForSignedUrl: SignedUrlDownloadRequestBody = {
    filename: receivedAction.payload.file.name,
    type: receivedAction.payload.type,
  }

  const url = URL + Endpoint.VISUAL_DOWNLOAD_URL
    .replace('{assignmentId}', encodeURIComponent(receivedAction.payload.missionId.toString()))
    .replace('{filename}', encodeURIComponent(receivedAction.payload.file.name.toString()))
    .replace('{type}', encodeURIComponent(receivedAction.payload.type.toString()))

  const fetchFunction = () => generalFetch(ActionTypeAPIData.LOAD_VISUAL, () => axios.post<UrlDTO>(url, dataForSignedUrl, {
    headers: {
      Authorization: `Bearer ${token}`,
      Accept: mimetype,
    },
  }))

  let actionContainingSignedUrl: ActionRequest = await fetchFunction()
  for (let i = 0; i < iterationCount; i++) {
    if (actionContainingSignedUrl.payload.request.response?.status !== 503) break
    await waitFor(delayTime)
    actionContainingSignedUrl = await fetchFunction()
  }

  const URLResponse: UrlDTO = actionContainingSignedUrl.payload.request.data
  const downloadedAction: ActionLoadVisual = {
    ...actionContainingSignedUrl,
    payload: {
      ...receivedAction.payload,
      ...actionContainingSignedUrl.payload,
      signedUrl: URLResponse?.url,
    }
  }

  if (downloadedAction.payload.request.response) {
    const { data, headers, status, statusText, config } = downloadedAction.payload.request.response
    const newResponse: AxiosResponse = { data, headers, status, statusText, config: JSON.parse(JSON.stringify(config)) }
    downloadedAction.payload.request.response = newResponse
  }

  if (downloadedAction.payload.request.state === APIRequestState.ERROR) {
    const response = downloadedAction.payload.request.response?.data as StatusResponseBody
    let resultCode: string | undefined = ''
    if (response) {
      resultCode = response.message
    } else {
      resultCode = downloadedAction.payload.request.error.message
    }
    const error_message = `Image processing result code: ${resultCode}`
    console.error(error_message)
    downloadedAction.payload.request.error = resultCode
    return downloadedAction
  }

  for (let i = 0; i < iterationCount; i++) {
    try {
      await axios.get<unknown>(URLResponse.url)
      return downloadedAction
    } catch (error) {
      // PUT error if necessary
    }
    await waitFor(delayTime)
  }

  downloadedAction.payload.request = APIRequest.factoryError(APIRequestErrorType.NOTFOUND_ERROR, 'Visual not found')

  return downloadedAction
}

export type downloadVisualWorkerType = typeof downloadVisualWorker

expose(downloadVisualWorker)
